import cn from 'classnames';
import { FunctionComponent, PropsWithChildren } from 'react';

export type RadioButtonProps = {
    id: string;
    name?: string;
    checked: boolean;
    hidden?: boolean;
    className?: string;
    labelClassName?: string;
};

export const RadioButton: FunctionComponent<PropsWithChildren<RadioButtonProps>> = ({
    checked,
    id,
    className,
    children,
    hidden,
    labelClassName
}) => {
    return (
        <div className={cn('group hover:cursor-pointer flex items-center gap-2', { 'pt-2': !className }, className)}>
            <div
                aria-checked={checked}
                role="radio"
                className={cn('relative w-3 h-3 border rounded-full bg-transparent cursor-pointer', {
                    'border-brand-primary group-hover:border-brand-primary-dark': checked,
                    'group-hover:border-neutral-300': !checked,
                    hidden: hidden
                })}>
                {checked && (
                    <div className="absolute w-1.5 h-1.5 bg-brand-primary group-hover:bg-brand-primary rounded-full transform -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2" />
                )}
            </div>
            <label htmlFor={id} className={cn('cursor-pointer whitespace-nowrap', labelClassName)}>
                {children}
            </label>
        </div>
    );
};
